import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import SearchBar from "./StockSearch";
import StockDetails from "./StockDetails_dash";
import Fundamental from "./Fundamental";

const Fundamentaldash = () => {
    const [selectedCompany, setSelectedCompany] = useState(null);
    
    return (
        <>
            <SearchBar onSelect={setSelectedCompany} />
            <Routes>
                <Route path="/*" element={<StockDetails selectedCompany={selectedCompany} />} />
            </Routes>
            
        </>
    );
};

export default Fundamentaldash;
